// extracted by mini-css-extract-plugin
export default {"bookmarkHeading":"Bookmarks_bookmarkHeading__FsPeU","clearAll":"Bookmarks_clearAll__NCrGh"};